import { Component, OnInit, Inject } from '@angular/core';
import { MainMapService } from 'src/app/shared/service/main-map.service';
import { WidgetService } from 'src/app/shared/service/widget.service';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS_VALUE } from '../../../config/constants.module';

@Component({
    selector: 'custom-searches',
    templateUrl: './custom-searches.component.html',
    styleUrls: ['./custom-searches.component.scss'],
    standalone: false
})
export class CustomSearchesComponent implements OnInit {
  public dropDownLabel: string;

  constructor(
    private _translate: TranslateService,
    private _mainMapService: MainMapService,
    private _widgetService: WidgetService
  ) {}

  ngOnInit() {
    this._translate.get('HEADER_PANEL.SEARCH_DROPDOWN').subscribe(label => {
      this.dropDownLabel = label;
    });
  }

  /**
   * @function showSearchParzellenWidget
   * @description Shows parzellen widget to search it base on Gemeinde
   */
  public showSearchParzellenWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.SearchParzelleComponent);
  }

  public showSearchParzellenCHWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.SearchParzelleCHComponent);
  }

  public showSearchHektometerWidget() {
    this._mainMapService.closeWidgets();
    this._widgetService.createWidget(true, CONSTANTS_VALUE.WIDGET_ID.SearchHektometerComponent);
  }
}
